'use strict';

var Marionette = require('backbone.marionette');
var polyglot = require('../../utilities/polyglot').default;

var StaffListView = require('./list').default;

export default Marionette.View.extend({

  className: 'staff-list',
  template: require('./templates/list.hbs'),
  backButton: '.staff-list-back',
  nextButton: '.staff-list-next',

  regions: {
    content: {
      el: ".staff-list-employees",
      replaceElement: true,
    },
  },

  ui: {
    back: '.staff-list-back',
    next: '.staff-list-next',
  },

  events: {
    'click @ui.back': 'onClickBack',
    'click @ui.next': 'onClickNext',
  },

  initialize: function () {
    this.staff_id = null;
    this.staffListView = new StaffListView({
      collection: this.collection,
    });
    this.listenTo(this.staffListView, 'change:staff', this.onClickEmployee);
    this.listenTo(this.staffListView, 'updateBackAndNextButtons', this.updateBackAndNextButtonState);
  },

  setStaffId: function ($staff_id) {
    this.staff_id = $staff_id;
    this.staffListView.setStaffId(this.staff_id);
  },

  onRender: function () {
    this.showChildView('content', this.staffListView);
  },

  onClickEmployee: function (model) {
    this.triggerMethod('change:staff', model);
  },

  handleEmptyCollection: function () {
    this.ui.back.hide();
    this.ui.next.hide();
  },


  //THE PAGED COLLECTION FUNCTIONALITY

  isBackEnabled: function () {
    return (this.staffListView.currentPage > 1);
  },

  isNextEnabled: function () {
    return (this.staffListView.currentPage < this.staffListView.getNumberOfPages());
  },

  updateBackAndNextButtonState: function () {
    var $back = this.getBackButton();
    var $next = this.getNextButton();

    if ($back) {
      if (!this.isBackEnabled()) {
        $back.addClass('disabled');
      } else {
        $back.removeClass('disabled');
      }
    }

    if ($next) {
      if (!this.isNextEnabled()) {
        $next.addClass('disabled');
      } else {
        $next.removeClass('disabled');
      }
    }
  },

  getBackButton: function () {
    if (!this.backButton) {
      return null;
    }

    if (!this.$backButtonEl) {
      this.$backButtonEl = this.$(this.backButton);
    }

    return this.$backButtonEl;
  },

  getNextButton: function () {
    if (!this.nextButton) {
      return null;
    }

    if (!this.$nextButtonEl) {
      this.$nextButtonEl = this.$(this.nextButton);
    }

    return this.$nextButtonEl;
  },

  onClickBack: function (evt) {
    evt.preventDefault();
    this.back();
  },

  back: function () {
    if (!this.isBackEnabled()) return;

    this.staffListView.moveToPrevPage();
    this.updateBackAndNextButtonState();
  },

  onClickNext: function (evt) {
    evt.preventDefault();
    this.next();
  },

  next: function () {
    if (!this.isNextEnabled()) return;
    this.staffListView.moveToNextPage();
    this.updateBackAndNextButtonState();
  },

});
